import { GenericModel } from "../../../generic.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { GenericTotalModel } from "./genericTotal.model";
import { CurrencyModel } from "../../common/currency.model";
import {
    EVehicleRowType,
    IVehicleRentalPriceRow
} from "../../../../component/booking-information/components/booking-price-card/components/vehicle-rental-price-tab/interfaces/vehicle-rental-price-intefaces";


export class TotalModel extends GenericModel {
    public baseArray: GenericTotalModel[];
    public feeArray: GenericTotalModel[];
    public supplementArray: GenericTotalModel[];
    public totalArray: GenericTotalModel[];

    public get sumTotalWithoutXReason(): any {
        let sumTotalWithoutXReason: number = 0;
        const currency: string = this.totalArray[0].currencyArray[0].currencyCode;
        const decimals: number = this.totalArray[0].currencyArray[0].decimals;
        this.totalArray.find((t: GenericTotalModel) => t.xReason === null).currencyArray.map((c: CurrencyModel) => sumTotalWithoutXReason += c.value);
        return {
            amount: sumTotalWithoutXReason,
            currency,
            decimals,
            value: sumTotalWithoutXReason
        };
    }

    public get sumTotal(): any {
        let sumTotal: number = 0;
        const currency: string = this.totalArray[0].currencyArray[0].currencyCode;
        const decimals: number = this.totalArray[0].currencyArray[0].decimals;
        this.totalArray
            .map((total: GenericTotalModel): void[] => total.currencyArray
                .map((c: CurrencyModel): void => { sumTotal += c.value; }));
        return {
            amount: sumTotal,
            currency,
            decimals,
            value: sumTotal
        };
    }

    public sumServiceByxSellLocation(xSellLocation: ('Merchant' | 'Local'), title: string): IVehicleRentalPriceRow {
        const totalServiceObject: GenericTotalModel = this.totalArray?.find((total: GenericTotalModel): boolean =>
            total.xReason === 'Service' && total.xSellLocation === xSellLocation);
        return {
            title,
            type: EVehicleRowType.service,
            total: {
                amount: +totalServiceObject?.currencyArray[0]?.amount,
                currency: totalServiceObject?.currencyArray[0]?.currencyCode
            },
            collapseGroup: xSellLocation
        };
        return null;
    }

    public get sumSupplement(): any {
        if (this.supplementArray.length > 0) {
            let sumSupplement: number = 0;
            const currency: string = this.supplementArray[0].currencyArray[0].currencyCode;
            const decimals: number = this.supplementArray[0].currencyArray[0].decimals;
            this.supplementArray
                .map((supplement: GenericTotalModel): void[] => supplement.currencyArray
                    .map((c: CurrencyModel): void => { sumSupplement += c.value; }));
            return sumSupplement > 0 ? {
                amount: sumSupplement,
                currency,
                decimals,
                value: sumSupplement
            } : null;
        }
        return null;
    }

    protected fromJson(json?: any): boolean {
        this.baseArray = makeModel(json.baseArray, GenericTotalModel);
        this.feeArray = makeModel(json.feeArray, GenericTotalModel);
        this.supplementArray = makeModel(json.supplementArray, GenericTotalModel);
        this.totalArray = makeModel(json.totalArray, GenericTotalModel);
        return this.isValid();
    }

    protected isValid(): boolean {
        return this.totalArray !== null && this.totalArray.length > 0 && this.supplementArray !== null;
    }
}
